<template>
  <DashboardScaleScores />
</template>

<script>
import DashboardScaleScores from "../components/DashboardScaleScores.vue";

export default {
  name: "DashboardScaleScoresView",

  components: {
    DashboardScaleScores,
  },
};
</script>
